module.exports = __webpack_public_path__ + "img/banner_total.3716d9da.png";